import React from 'react';
import { Row, Col, Card as RBCard } from "react-bootstrap";
import ApartmentIcon from "@mui/icons-material/Apartment";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import TimelineIcon from "@mui/icons-material/Timeline";
import { Avatar, Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { paths } from '../../../../utils/path';

const NationalCards = ({ data, stateWiseData }) => {
    const navigate = useNavigate();

    const handleNavigation = (type) => {
        navigate(
            `${paths?.user?.commonPoint}${paths?.user?.adminStatewiseStats}`,
            {
                state: {
                    type: type,
                    stateWiseData: stateWiseData
                }
            }
        );
    };

    return (
        <Row className="mt-3" xs={1} sm={2} lg={4}>
            
            {/* TCCC */}
            <Col className="mb-3">
                <RBCard className="shadow-sm border-0 rounded-4">
                    <RBCard.Body>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray">
                                Total TCCC
                            </Typography>

                            <Avatar sx={{ bgcolor: "#E0E7FF" }}>
                                <ApartmentIcon sx={{ color: "#6C7FF9" }} />
                            </Avatar>
                        </Box>

                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mt={4}
                        >
                            <Typography variant="h5" fontWeight={600}>
                                {data?.MI_facilities || "0"}
                            </Typography>

                            <Button
                                variant="outlined"
                                className='viewBtnAdmin'
                                onClick={() => handleNavigation('tccc')}
                            >
                                View
                            </Button>

                        </Box>
                    </RBCard.Body>
                </RBCard>
            </Col>

            {/* DCCC */}
            <Col className="mb-3">
                <RBCard className="shadow-sm border-0 rounded-4">
                    <RBCard.Body>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray">
                                Total DCCC
                            </Typography>

                            <Avatar sx={{ bgcolor: "#E0E7FF" }}>
                                <BusinessIcon sx={{ color: "#6C7FF9" }} />
                            </Avatar>
                        </Box>

                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mt={4}
                        >
                            <Typography variant="h5" fontWeight={600}>
                                {data?.DCCC_facilities || "0"}
                            </Typography>

                            <Button
                                variant="outlined"
                                className='viewBtnAdmin'
                                onClick={() => handleNavigation('dccc')}
                            >
                                View
                            </Button>

                        </Box>
                    </RBCard.Body>
                </RBCard>
            </Col>

            {/* Registered Beneficiaries */}
            <Col className="mb-3">
                <RBCard className="shadow-sm border-0 rounded-4">
                    <RBCard.Body>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray" sx={{ pr: 1.25 }}>
                                Total Registered Beneficiaries
                            </Typography>

                            <Avatar sx={{ bgcolor: "#E0E7FF" }}>
                                <GroupsIcon sx={{ color: "#6C7FF9" }} />
                            </Avatar>
                        </Box>

                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mt={4}
                        >
                            <Typography variant="h5" fontWeight={600}>
                                {data?.total_patients || "0"}
                            </Typography>

                            <Button
                                variant="outlined"
                                className='viewBtnAdmin'
                                onClick={() => handleNavigation('beneficiaries')}
                            >
                                View
                            </Button>

                        </Box>
                    </RBCard.Body>
                </RBCard>
            </Col>

            {/* Total Chemo Sessions */}
            <Col className="mb-3">
                <RBCard className="shadow-sm border-0 rounded-4">
                    <RBCard.Body>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Typography variant="body2" color="gray">
                                Total Completed Chemo Sessions
                            </Typography>

                            <Avatar sx={{ bgcolor: "#E0E7FF" }}>
                                <TimelineIcon sx={{ color: "#6C7FF9" }} />
                            </Avatar>
                        </Box>

                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            mt={4}
                        >
                            <Typography variant="h5" fontWeight={600}>
                                {data?.total_chemo || "0"}
                            </Typography>

                            <Button
                                variant="outlined"
                                className='viewBtnAdmin'
                                onClick={() => handleNavigation('chemo')}
                            >
                                View
                            </Button>

                        </Box>
                    </RBCard.Body>
                </RBCard>
            </Col>
        </Row>
    )
}

export default NationalCards